import 'jquery-match-height'
import LazyLoad from 'vanilla-lazyload'
import overlayMenu from '../layout/overlay-menu';
import slider from '../layout/sliders';
import sticky from '../layout/sticky';
import popup from '../layout/popup';
import sidebars from '../layout/sidebars'
import GLightbox from 'glightbox';
import facetwp from '../layout/facetwp';
import filters from '../layout/filters';

export default {
  init() {
  
  popup();

  GLightbox({
    selector: '.glightbox',
  })

  GLightbox({
    selector: '.single-gallery',
  })

    new LazyLoad({
      elements_selector: '.lazy',
    })

    slider()
    sticky()
    filters()

  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js